import React, { useEffect, useRef, useState } from "react";
import LayoutV2 from "../../../components/layout-v2";
import OptionSelector from "../common/option-selector";
import UButton from "ubs-framework/v2/UButton";
import { CONFIGURATION_TYPE, GOAL_OPTIONS, SIGNUP_STEPS } from "../../../common/constant";
import { sendData } from "../../../store/actions";
import { useDispatch } from "react-redux";
import { getCookie } from "ubs-framework/v2/common/function";
import UCheckBox from "ubs-framework/v2/UCheckBox";
import { useHistory, useParams } from "react-router-dom";
import useSocket from "../../common/useSocket";
import { clearValidation, errorFocus, showToastSuccess } from "ubs-framework/v2/common/function";
import * as Icon from "ubs-icons"
import { COLOR } from "../../../common/constant";
import useUAlert from "ubs-framework/v2/UAlert";
import Skeleton from "ubs-framework/v2/skeleton";
import { withRouter } from "../../../common/hocs/routing-hoc";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Validator from "simple-react-validator";

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const CompanyOtherInfo = () => {
    const history = useHistory();
    const alert = useUAlert();
    const { orgId } = useParams();
    const dispatch = useDispatch();
    const [step, setStep] = useState(0);
    const [stepsData, setStepsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState({
        usagePurpose: null,
        referralSource: null,
        managementFocus: null,
        empCount: null,
        usedTools: [],
        userGoals: []
    });
    const currentGroup = stepsData?.[step] || {};

    const forceUpdate = useForceUpdate();
    const validator = useRef(
        new Validator({
        element: (message) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: { forceUpdate }
        })
    );

    useEffect(() => {
        on();
        sendData(dispatch, 'superworks|configurationV2', { type: CONFIGURATION_TYPE.REGISTRATION_STEPS });
        return () => off();
    }, [])

    const handleSelect = (key, option, multiSelect) => {
        const normalized =
            typeof option === "string"
                ? { label: option }
                : { label: option.label, ...(["other", "Other", "None of the above"]?.includes(option.label) && { value: option.value || "" }) };

        if (multiSelect) {
            const current = Array.isArray(formData[key]) ? formData[key] : [];
            const exists = current.find((o) => o.label === normalized.label);

            if(exists) {
                clearValidation(validator, [option?.key]);
            }
            const updated = exists
                ? current.filter((o) => o.label !== normalized.label)
                : [...current, { ...normalized, key }];

            setFormData((prev) => ({ ...prev, [key]: updated }));
        } else {
            setFormData((prev) => ({ ...prev, [key]: [{ ...normalized, key }] }));
        }
    };

    const formatFormDataForAPI = (data) => {
        const formatted = {};
        const arrayFields = ["managementFocus", "usedTools", "userGoals"]; // only these stay as arrays

        Object.entries(data || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                // Multi-select logic
                const mapped = value?.map((v) =>
                    v?.label === "Other" ? (v?.value || v?.label) : v?.label
                );

                // Keep as array ONLY for specific fields
                formatted[key] = arrayFields?.includes(key)
                    ? mapped
                    : mapped?.join(", "); // convert to string for all others
            } else if (typeof value === "object" && value !== null) {
                // Single-select logic
                formatted[key] =
                    value?.label === "Other" ? (value?.value || value?.label) : value?.label;
            } else {
                formatted[key] = value;
            }
        });

        return formatted;
    }

    const handleNext = () => {
        if(validator?.current?.allValid()) {
            if (step < stepsData?.length - 1) {
                setStep(step + 1);
            } else {
                const formattedData = formatFormDataForAPI(formData);
                let params = {
                    "token": getCookie('signup_token'),
                    "orgId": orgId,
                    ...formattedData
                }
                sendData(dispatch, 'account|signUp|updateCompany', params);
            }
        } else {
            validator?.current?.showMessages()
            errorFocus();
        }
    };

    const handleBack = () => {
        clearValidation(validator, ['other']);
        if (step > 0) setStep(step - 1);
    };

    const isStepComplete = () => {
        return currentGroup?.questions?.every((q) => {
            const val = formData[q.key];
            
            return q?.multiSelect
                ? Array.isArray(val) && val?.length > 0 && (val?.some(v => typeof v?.value !== "undefined") ? val?.some(e => e.value?.length > 0) : true)
                : Array.isArray(val) && val[0]?.value?.toString().trim() !== "";
        });
    };

    useEffect(() => {
        refresh();
        return () => off();
    }, []);

    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'account|signUp|updateCompany': {
                    const slugType = localStorage.getItem('slugType') || 'track'
                    showToastSuccess(res?.data?.message || 'Company Details added successfully')
                    if (res?.data?.signUpStep) {
                        localStorage.setItem('signUpStep', res?.data?.signUpStep)
                    }
                    if (res?.data?.orgInfo?.orgId) {
                        localStorage.setItem('signUpOrgId', res?.data?.orgInfo?.orgId)
                    }
                    if ([1]?.includes(res?.data?.signUpStep)) history.push(`/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}?email=${res?.data?.email}`)
                    else if ([2]?.includes(res?.data?.signUpStep)) history.push(`/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}`)
                    else if ([3, 4]?.includes(res?.data?.signUpStep)) history.push(`/${res?.data?.orgInfo?.orgId}/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}`)
                    break;
                }
                case 'superworks|configurationV2': {
                    setIsLoading(false);
                    if (res?.data?.config?.type === CONFIGURATION_TYPE.REGISTRATION_STEPS) {
                        const info = res?.data?.config?.info || {};
                        // dynamically build steps array

                        const dynamicSteps = [
                            {
                                group: "usage",
                                questions: [
                                    { title: "What will you use Super Track for?", key: "usagePurpose", options: info.PURPOSE_OPTIONS },
                                    { title: "How did you hear about us?", key: "referralSource", options: info.SOURCE_OPTIONS }
                                ]
                            },
                            {
                                group: "team",
                                questions: [
                                    { title: "What would you like to manage?", key: "managementFocus", options: info.MANAGE_OPTIONS, multiSelect: true },
                                    { title: "How many people are on your team?", key: "empCount", options: info.TEAM_SIZE_OPTIONS }
                                ]
                            },
                            {
                                group: "tools",
                                questions: [
                                    { title: "Do you use any of these tools?", key: "usedTools", options: info.TOOL_OPTIONS?.map(t => ({ ...t, label: t.label.replace("None of the above", "Other") })), multiSelect: true }
                                ]
                            },
                            {
                                group: "goals",
                                questions: [
                                    { title: "Choose one or more goals you want?", key: "userGoals", options: info.GOAL_OPTIONS, multiSelect: true }
                                ]
                            }
                        ];

                        setStepsData(dynamicSteps);
                    }
                    break;
                }
                default:
                    return true;
            }
        } else {
            alert.show({ title: 'Oops...!', description: res?.data?.error, })
        }
    })

    return (
        <LayoutV2 module="companyOtherInfo" className={`${currentGroup?.group === 'goals' ? 'u_collect-details-goal' : 'u_collect-details'}`}>
            <div className="u_p-24">
                {isLoading ? <div className="u_row u_mb-30 u_content-center">
                    {Array.from({ length: 20 }, (_, index) => (
                        <div key={index} className="u_mb-16 u_mx-4">
                            <Skeleton width="100px" height="30px" className="u_border-radius-6" />
                        </div>
                    ))}
                </div> :
                    currentGroup?.questions?.map((question, index) => {
                        return (
                            <div key={index} className="u_mb-32">
                                {currentGroup?.group === 'goals' ? <>
                                    <h4 className="u_title u_text-center u_text-bold u_mt-16 u_mb-20">
                                        {question?.title}
                                    </h4>
                                    {question?.options?.map((goal) => (
                                        <div
                                            key={goal?.label}
                                            className={`u_label u_border-radius-6 u_p-12 u_flex-align u_mb-16 u_cp ${formData?.userGoals?.some(g => g?.label === goal?.label) ? "active" : ""
                                                }`}
                                            onClick={() => handleSelect(question?.key, goal?.label, true)}
                                        >
                                            <div className="u_flex-align">
                                                <div className={`u_label u_p-14 u_border-radius-8 ${formData?.userGoals?.some(g => g?.label === goal?.label) ? "active" : ""}`}>
                                                    <Icon.Clock fill={COLOR.u_icon_bg} size="20" />
                                                </div>

                                                <div className="u_ml-12 u_flex-grow-1">
                                                    <h6 className="u_small-font u_text-bold u_mb-6">{goal?.label}</h6>
                                                    <p className="u_small-font">{goal?.desc}</p>
                                                </div>
                                            </div>

                                            <UCheckBox
                                                id={goal?.label}
                                                label=""
                                                checked={formData?.userGoals?.some(g => g?.label === goal?.label)}
                                                onChange={() => handleSelect(question?.key, goal?.label, true)}
                                                testId={TEST_ID.COMPANY_OTHER_INFO.CHECKBOX} />
                                        </div>
                                    ))} </>
                                    :

                                    <OptionSelector
                                        title={question.title}
                                        options={question.options}
                                        mainKey={question.key}
                                        selected={formData[question.key]}
                                        onSelect={handleSelect}
                                        multiSelect={question.multiSelect}
                                        formData={formData}
                                        setFormData={setFormData}
                                        validator={validator}
                                    />
                                }
                            </div>
                        );
                    })}

                <div className="u_row u_content-between">
                    <div className="u_col-6">
                        {step === 0 ? <></> : <UButton
                            style={{ borderRadius: "6px" }}
                            variant="white"
                            type="back"
                            disabled={step === 0}
                            onClick={handleBack}
                            testId={TEST_ID.COMPANY_OTHER_INFO.BUTTON} />}
                    </div>

                    <div className="u_col-6 u_flex u_content-end">
                        <UButton
                            style={{ borderRadius: "6px" }}
                            variant="blue"
                            type="continue"
                            disabled={!isStepComplete()}
                            onClick={handleNext}
                            testId={TEST_ID.COMPANY_OTHER_INFO.BUTTON} />
                    </div>
                </div>
            </div>
        </LayoutV2>
    );
};

export default withRouter(CompanyOtherInfo);
